import { module } from 'modujs';

export default class extends module {

    constructor(m) {
        super(m);

        this.settings = {
            columns: this.getData('columns', this.el) || 16,
            gutter: this.getData('gutter', this.el) || 'var(--grid-gutter)',
            margin: this.getData('margin', this.el) || 'var(--grid-gutter)',
            color: this.getData('color', this.el) || 'rgba(255, 0, 0, .1)',
        }
    }

    init() {
        this.setColumns()
        this.setStyles()
        this.bindEvents()
    }

    setColumns() {
        let $col
        for (var i = 0; i < this.settings.columns; i++) {
            $col = document.createElement('div');
            this.el.appendChild($col);
        }
    }

    setStyles() {
        this.el.style.zIndex = '10000'
        this.el.style.position = 'fixed'
        this.el.style.top = '0'
        this.el.style.left = '0'
        this.el.style.display = 'flex'
        this.el.style.width = '100%'
        this.el.style.height = '100%'
        this.el.style.columnGap = this.settings.gutter
        this.el.style.paddingLeft = this.settings.margin
        this.el.style.paddingRight = this.settings.margin
        this.el.style.pointerEvents = 'none'
        this.el.style.visibility = 'hidden'

        const $children = this.el.children

        for(let $col of $children) {
            $col.style.flex = '1 1 0'
            $col.style.backgroundColor = this.settings.color
        }
    }

    bindEvents() {

        let ctrlDown = false
        let isActive = false
        document.addEventListener('keydown', (e) => {
            if(e.key == 'Control') {
                ctrlDown = true;
            } else {
                if(ctrlDown && e.key == 'g') {

                    if(isActive) {
                        this.el.style.visibility = 'visible'
                    } else {
                        this.el.style.visibility = 'hidden'
                    }

                    isActive = !isActive
                }
            }
        })

        document.addEventListener('keyup', (e) => {
            if(e.key == 'Control') {
                ctrlDown = false
            }
        })
    }
}
